<script lang="ts">
  import TeaserSection from "./TeaserSection.svelte";
  import type { InternalLinkingModule, Teaser } from "./types/shared";

  let { module }: { module: InternalLinkingModule } = $props();

  const teaser: Teaser = $derived({
    title: module.title,
    description: module.content,
    image: module.image,
    button: module.link.label,
  });
</script>

<TeaserSection
  --picture-object-fit="cover"
  class="my-16"
  {teaser}
  href={module.link.href}
  hrefLabel={module.link.label}
/>
